import { Directive, ElementRef } from '@angular/core';
import { AppState } from '../../config/state';
import { Events } from 'ionic-angular';

/**
 * Generated class for the LoginHeaderDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[login-header]' // Attribute selector
})
export class LoginHeaderDirective {
  headerTextTemplate: string = `<span class="headerLoginText">You are logged in.</span>`
  headerTextElement: any;
  constructor(private state: AppState, private events: Events, private el: ElementRef) {
  }

  ngOnInit() {
    if (this.state.patron) {
      this.showLoggedInState();
    } else {
      let self = this;
      this.events.subscribe('patronLoggedIn', (status) => {
        if (status) {
          self.showLoggedInState();
        } else {
          // console.log('login remove ran')
          if (this.headerTextElement !== undefined && this.headerTextElement !== null) {
            this.headerTextElement.parentElement.removeChild(this.headerTextElement);
            this.headerTextElement = undefined;
          }
        }
      });
    }
  }

  showLoggedInState() {
    let nativeElement = this.el.nativeElement;
    // console.log(this.headerTextElement);
    nativeElement.insertAdjacentHTML('afterend', this.headerTextTemplate);
    this.headerTextElement = nativeElement.nextSibling;
  }

}



// WEBPACK FOOTER //
// ./src/directives/login-header/login-header.ts